module.exports = __webpack_public_path__ + "static/EnmTX_BosYvon_L_A_cl-8552f43f04e6763fe034d27018914c16.gif";